<template>
    <div class="container">
        <div id="line" ref="line">
            <div id="oLine" :style="rightWidth" />
        </div>
        <div class="row" id="label-group">
            <p class="label">{{ labels[0] }} ({{ Math.round((values[0] / (values[0] + values[1])) * 100) }}%)</p>
            <p class="label">{{ labels[1] }} ({{ Math.round((values[1] / (values[0] + values[1])) * 100) }}%)</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "LineChart",
    props: {
        values: {
            type: Array,
            required: true,
        },
        labels: Array,
    },
    computed: {
        rightWidth: function() {
            return { width: `${this.width * (this.values[1] / (this.values[0] + this.values[1]))}px` };
        },
    },
    methods: {
        setChartWidth() {
            this.width = this.$refs.line.getBoundingClientRect().width;
        },
    },
    mounted() {
        this.setChartWidth();
        window.addEventListener("resize", this.setChartWidth);
    },
    data() {
        return {
            width: null,
        };
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_main.scss";

$left: #8fbedf;
$right: #fe5775;

#line {
    height: 14px;
    width: 100%;

    background-color: $left;
    border-radius: 99px;
}

#oLine {
    float: right;

    height: 100%;

    background-color: $right;
    border-radius: 99px;
}

#label-group {
    justify-content: space-between;

    width: 100%;

    :first-child {
        color: $left;
    }

    :nth-child(2) {
        color: $right;
    }

    > * {
        margin: 3px 0 0 0;
        font-size: 14px;
    }
}

@media only screen and (max-width: $breakpoint-medium) {
    #line {
        height: 30px;
        border-radius: 6px;
    }

    #oLine {
        border-radius: 6px;
    }
}
</style>
